import { render, staticRenderFns } from "./DormUserDorms.vue?vue&type=template&id=318bbb73&"
import script from "./DormUserDorms.vue?vue&type=script&lang=js&"
export * from "./DormUserDorms.vue?vue&type=script&lang=js&"
import style0 from "./DormUserDorms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports